<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PP1.w.1.0.0"></a><a id="GBS.PP1.w.2.0.0"></a></div>
<div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PP1.w.3.0.0"></a><a id="GBS.PP1.w.3.0.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PR1"></a>
<div class="gtxt_body" id="block.2.0.0.box.48.324.1536.548.q.80">
<a id="ORIG-GBS.PR1.w.0.0.0"></a><p class="gtxt_body" id="para.2.0.0.box.48.324.1536.548.q.80" style="font-size:200%;text-indent:1em;text-align:center;font-weight:bold;text-indent:0;"><a id="GBS.PP1.w.4.0.0"></a><a id="GBS.PP1.w.5.0.0"></a><a id="GBS.PP2"></a><a id="GBS.PP2.w.0.0.0"></a><a id="GBS.PR1"></a><a id="GBS.PR1.w.0.0.0"></a>THE CRASH OF <a id="GBS.PR1.w.0.0.0.1"></a><a id="GBS.PR1.w.0.1.0"></a><span style="font-style: italic;"><a id="GBS.PR1.w.1.0.0"></a><a id="GBS.PR1.w.2.0.0"></a><a id="GBS.PR2"></a><a id="GBS.PR2.w.0.0.0"></a>LITTLE EVA </span></p><a id="GBS.PR3"></a><a id="GBS.PR3.w.0.0.0"></a><a id="GBS.PR3.w.0.1.0"></a>
</div><a id="GBS.PR3.w.1.0.0"></a><a id="GBS.PR3.w.2.0.0"></a>
</div><div style="display:none;"><a id="GBS.PR3.w.3.0.0"></a></div><div style="display:none;"><a id="GBS.PR3.w.4.0.0"></a></div><div style="display:none;"><a id="GBS.PR3.w.5.0.0"></a></div>
<div style="display:none;"><a id="GBS.PR3.w.5.0.0.1"></a></div><div style="display:none;"><a id="GBS.PR3.w.5.1.0"></a></div><div class="flow" style=""><a id="GBS.PR4"></a><a id="GBS.PR4.w.0.0.0"></a>
</div><div style="display:none;"><a id="GBS.PR4.w.0.1.0"></a><a id="GBS.PR4.w.0.2.0"></a><a id="GBS.PR4.w.0.3.0"></a><a id="GBS.PR4.w.1.0.0"></a><a id="GBS.PR4.w.1.1.0"></a><a id="GBS.PR4.w.1.2.0"></a><a id="GBS.PR4.w.2.0.0"></a><a id="GBS.PR4.w.3.0.0"></a><a id="GBS.PR4.w.3.1.0"></a><a id="GBS.PR4.w.3.2.0"></a><a id="GBS.PR5"></a><a id="GBS.PR5.w.0.0.0"></a><a id="GBS.PR5.w.1.0.0"></a><a id="GBS.PR5.w.2.0.0"></a><a id="GBS.PR5.w.3.0.0"></a><a id="GBS.PR5.w.4.0.0"></a><a id="GBS.PR5.w.4.1.0"></a><a id="GBS.PR5.w.4.2.0"></a><a id="GBS.PR5.w.4.3.0"></a><a id="GBS.PR5.w.4.4.0"></a><a id="GBS.PR5.w.4.5.0"></a><a id="GBS.PR5.w.4.6.0"></a><a id="GBS.PR5.w.4.7.0"></a><a id="GBS.PR5.w.4.8.0"></a><a id="GBS.PR5.w.5.0.0"></a><a id="GBS.PR5.w.6.0.0"></a><a id="GBS.PR5.w.7.0.0"></a><a id="GBS.PR5.w.8.0.0"></a><a id="GBS.PR5.w.9.0.0"></a><a id="GBS.PR5.w.10.0.0"></a><a id="GBS.PR6"></a><a id="GBS.PR6.w.0.0.0"></a><a id="GBS.PR7"></a><a id="GBS.PR7.w.0.0.0"></a><a id="GBS.PR8"></a><a id="GBS.PR8.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PR9"></a><a id="GBS.PR9.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PR9.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PR9.w.0.0.0.2"></a></div><div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PR3"></a>
<a id="GBS.PR9.w.0.0.0.3"></a><img alt="Image for page 4" src="data/content-0002.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PR9.w.0.0.0.4"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PR4"></a>
<a id="GBS.PR9.w.0.0.0.5"></a><img alt="Image for page 5" src="data/content-0003.png" style="max-width:100%; max-height:100%"/><a id="GBS.PR9.w.0.0.0.6"></a></div>
<div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PR5"></a>
</div>
<div style="display:none;"><a id="GBS.PR9.w.0.0.0.7"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0004.vue?43df1636